import React from 'react';
import PageLayout from '../components/PageLayout';

const CookiePolicyPage = () => {
  return (
    <PageLayout title="Cookie Policy">
      <div className="space-y-8 text-slate-600">
        <p className="text-sm text-slate-500">Last Updated: January 1, 2026</p>
        
        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">What Are Cookies?</h2>
          <p>
            Cookies are small text files that are stored on your device when you visit a website or use 
            an application. They help us provide you with a better experience by remembering your preferences 
            and understanding how you use our services.
          </p>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">How We Use Cookies</h2>
          <p className="mb-4">We use cookies and similar technologies for the following purposes:</p>
          
          <h3 className="font-manrope text-xl font-semibold text-slate-800 mb-3">Essential Cookies</h3>
          <p className="mb-4">
            These cookies are necessary for our services to function properly. They enable core functionality 
            such as security, authentication, and session management. You cannot opt out of these cookies.
          </p>
          
          <h3 className="font-manrope text-xl font-semibold text-slate-800 mb-3">Performance Cookies</h3>
          <p className="mb-4">
            These cookies help us understand how visitors interact with our services by collecting and 
            reporting information anonymously. This helps us improve our app and website performance.
          </p>
          
          <h3 className="font-manrope text-xl font-semibold text-slate-800 mb-3">Functionality Cookies</h3>
          <p className="mb-4">
            These cookies allow us to remember choices you make (such as your language preference or 
            display settings) and provide enhanced, personalized features.
          </p>
          
          <h3 className="font-manrope text-xl font-semibold text-slate-800 mb-3">Analytics Cookies</h3>
          <p>
            We use analytics services to help us understand how our services are being used. These cookies 
            collect information about your use of our app and website, which we use to compile reports and 
            improve our services.
          </p>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Third-Party Cookies</h2>
          <p>
            Some cookies may be set by third-party services that appear on our pages. We do not control 
            these third-party cookies. Please refer to the respective privacy policies of these third parties 
            for information about their cookies.
          </p>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Managing Cookies</h2>
          <p className="mb-4">
            You can control and manage cookies in several ways:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Browser Settings:</strong> Most browsers allow you to view, manage, delete, and block 
              cookies. Note that blocking all cookies may affect your experience with our services.
            </li>
            <li>
              <strong>Mobile Device Settings:</strong> Your mobile device may offer settings to limit ad 
              tracking or reset advertising identifiers.
            </li>
            <li>
              <strong>In-App Settings:</strong> Our app provides options to manage certain cookie preferences 
              within the Settings menu.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Cookie Retention</h2>
          <p>
            The length of time a cookie remains on your device depends on whether it is a "persistent" or 
            "session" cookie. Session cookies are deleted when you close your browser, while persistent 
            cookies remain until they expire or are deleted.
          </p>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Updates to This Policy</h2>
          <p>
            We may update this Cookie Policy from time to time to reflect changes in our practices or 
            for operational, legal, or regulatory reasons. We encourage you to review this policy periodically.
          </p>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Contact Us</h2>
          <p>
            If you have questions about our use of cookies, please contact us at:
          </p>
          <div className="mt-4 p-4 bg-slate-100 rounded-lg">
            <p className="font-semibold">SignalPath Digital Health Applications, LLC</p>
            <p>Email: support@signalpathdigitalapps.com</p>
            <p>Phone: 1-800-555-0123</p>
          </div>
        </section>
      </div>
    </PageLayout>
  );
};

export default CookiePolicyPage;
